<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">设置物联网卡的ICCID</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="物联网卡的iccid号">
                <el-input v-model="addForm.iccid" placeholder="请输入物联网卡的iccid号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="物联网卡的手机号">
                <el-input v-model="addForm.phone" placeholder="请输入物联网卡的手机号"></el-input>
              </el-form-item>
            </el-col>

          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5, hex_md5_with_china,} from "@/common/Base64MD5";


export default {
  name: 'Add',
  data() {
    return {
      loading: false,

      addForm:{
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),

        deviceQLFallCode:'',
        iccid:'',
        phone:'',

      },

      rules:{
        iccid:[
          { required: true, message: '请输入物联网卡的iccid号', trigger: 'blur' },
        ],

      }


    }
  },
  components: {

  },
  methods: {
    init(row){
      this.$refs.addForm.resetFields();
      this.addForm.deviceQLFallCode = row.deviceQLFallCode;
      this.addForm.iccid = row.iccid;
      this.addForm.phone = row.wlkphone;
    },
    closeSelf() {
      this.$emit("closeMe");
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.addForm.iccid==null){this.addForm.iccid='';}
      if(this.addForm.phone==null){this.addForm.phone='';}

      this.addForm.sign = "";
      this.addForm.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(this.addForm) + "&key="+this.$signKey)

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceQLFall/SetICCIDPhone",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeMe");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })

    },


  }
}


</script>





<style lang="scss" scoped>

</style>
